import type { TranslationKey } from '@/i18n/i18n';
import { cn } from '@/utils/cn';
import { useTranslation } from 'react-i18next';

interface GridFooterProps {
  totalRecords: number;
  className?: string;
  labelKey?: string;
}

export const GridFooter = ({ totalRecords, className, labelKey = 'grid.footer.totalRecords' }: GridFooterProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'bg-background text-typography-500 flex w-full shrink-0 items-center justify-start px-3 py-1.5 text-xs',
        className
      )}
    >
      <span className="font-normal select-none">{t(labelKey as TranslationKey, { count: totalRecords })}</span>
    </div>
  );
};
